import React, { useEffect } from "react";
import Promise from "../../components/global/promise";
import AppDevImg from "../../assets/images/global/app.svg";
import EngTeamImg from "../../assets/images/global/engineering.svg";
import ServicesImg from "../../assets/images/global/services.svg";
import { useTranslation } from "react-i18next";

// Promise Component

const PromiseAppEngIt = ({ promiseContentItems }) => {
  const { t } = useTranslation();

  const promiseHeadline = `${t("marketsPages.solutionsHeadline")}`;

  const promiseContent = [
    {
      title: `${t("marketsPages.solutions.appDev.title")}`,
      textOne: `${t("marketsPages.solutions.appDev.text")}`,
      icon: <AppDevImg />,
      url: "/it-services/application-development",
      btnText: `${t("marketsPages.solutions.appDev.button")}`,
      key: "app-dev",
    },
    {
      title: `${t("marketsPages.solutions.engTeam.title")}`,
      textOne: `${t("marketsPages.solutions.engTeam.text")}`,
      icon: <EngTeamImg />,
      btnText: `${t("marketsPages.solutions.engTeam.button")}`,
      url: "/it-services/engineering-team",
      key: "eng-team",
    },
    {
      title: `${t("marketsPages.solutions.services.title")}`,
      textOne: `${t("marketsPages.solutions.services.text")}`,
      icon: <ServicesImg />,
      btnText: `${t("marketsPages.solutions.services.button")}`,
      url: "/it-services/other-services",
      key: "other-services",
    },
  ];

  let content = [];
  if (typeof promiseContentItems != "undefined") {
    content = promiseContent.filter(({ key }) =>
      promiseContentItems.includes(key)
    );
  }
  return (
    <Promise
      promiseContent={content}
      promiseHeadline={promiseHeadline}
      differentStyle="-centered"
    />
  );
};

export default PromiseAppEngIt;
